import { jsx as _jsx } from "react/jsx-runtime";
import { ContainerRelative, } from "../ContainerRelativeAbsolut";
import { getDataComponentName } from "../ui-interfaces";
// Cleans weired margin and paddings issues from flex parent containers for scrolled content
export const FlexCleaner = (props) => _jsx(ContainerRelative, Object.assign({}, props, { dataComponentName: getDataComponentName(props.dataComponentName, "FlexCleaner") }));
